import { PagedResult } from '../../shared/model/paged-result.model';
import { ProfileMin } from '../shared/profile-min.model';

export class ProfileSearchResult extends PagedResult {
  public constructor() {
    super();
    this.Result = new Array<ProfileMin>();
  }

  public Result: Array<ProfileMin>;
}
